(() => {
  const MOBILE_MQ = "(max-width: 749px)";

  const isMobile = () => window.matchMedia(MOBILE_MQ).matches;

  const getOpenStory = (root) => root.querySelector(".s26-story.is-open");

  const setExpanded = (story, expanded) => {
    story
      .querySelector("[data-s26-story-open]")
      ?.setAttribute("aria-expanded", expanded ? "true" : "false");
  };

  const lockScroll = (locked) => {
    document.documentElement.classList.toggle("s26-stories-modal-open", locked);
    document.body.classList.toggle("s26-stories-modal-open", locked);
  };

  const initStories = (root) => {
    if (!root || root.dataset.s26StoriesBound === "true") return;
    root.dataset.s26StoriesBound = "true";

    const backdrop = root.querySelector("[data-s26-stories-backdrop]");
    const stories = [...root.querySelectorAll("[data-s26-story]")];
    let lastFocus = null;

    const syncPanelRole = (story, open) => {
      const panel = story.querySelector("[data-s26-story-panel]");
      const popup = story.querySelector("[data-s26-story-popup]");
      const overlay = isMobile() ? popup : panel;
      [panel, popup].forEach((el) => {
        if (!el) return;
        el.removeAttribute("role");
        el.removeAttribute("aria-modal");
      });
      if (open && overlay) {
        overlay.setAttribute("role", "dialog");
        overlay.setAttribute("aria-modal", "true");
      }
    };

    const setStoryOpen = (story, open) => {
      const panel = story.querySelector("[data-s26-story-panel]");
      const popup = story.querySelector("[data-s26-story-popup]");
      story.classList.toggle("is-open", open);
      setExpanded(story, open);
      if (panel) panel.hidden = !open || isMobile();
      if (popup) popup.hidden = !open || !isMobile();
      syncPanelRole(story, open);
    };

    const closeStory = (story, { restoreFocus = true } = {}) => {
      if (!story?.classList.contains("is-open")) return;
      setStoryOpen(story, false);

      if (!getOpenStory(root)) {
        root.classList.remove("is-modal-open");
        if (backdrop) backdrop.hidden = true;
        lockScroll(false);
      }

      if (restoreFocus && lastFocus?.focus) {
        lastFocus.focus();
      }
    };

    const closeAll = (exceptStory) => {
      stories.forEach((story) => {
        if (exceptStory && story === exceptStory) return;
        closeStory(story, { restoreFocus: false });
      });
    };

    const openStory = (story, trigger) => {
      if (!story) return;
      const alreadyOpen = story.classList.contains("is-open");
      if (alreadyOpen) {
        closeStory(story);
        return;
      }

      closeAll(story);
      lastFocus = trigger || document.activeElement;
      setStoryOpen(story, true);

      if (isMobile()) {
        root.classList.add("is-modal-open");
        /* Backdrop stays transparent: mask is only on the popup card. */
        if (backdrop) backdrop.hidden = false;
        lockScroll(true);
      }
      story.querySelector(
        isMobile()
          ? "[data-s26-story-popup] [data-s26-story-close]"
          : "[data-s26-story-panel] [data-s26-story-close]"
      )?.focus();
    };

    stories.forEach((story) => {
      story.querySelector("[data-s26-story-open]")?.addEventListener("click", (event) => {
        event.preventDefault();
        openStory(story, event.currentTarget);
      });

      story.querySelectorAll("[data-s26-story-close]").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          closeStory(story);
        });
      });
    });

    backdrop?.addEventListener("click", () => {
      closeAll();
      lastFocus?.focus?.();
    });

    if (!document.body.dataset.s26StoriesKeysBound) {
      document.body.dataset.s26StoriesKeysBound = "true";
      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        document.querySelectorAll("[data-s26-stories]").forEach((section) => {
          const open = getOpenStory(section);
          if (!open) return;
          open.querySelector("[data-s26-story-close]")?.click();
        });
      });
    }

    const media = window.matchMedia(MOBILE_MQ);
    const onViewportChange = () => {
      const open = getOpenStory(root);
      if (!open) return;
      setStoryOpen(open, true);
      if (isMobile()) {
        root.classList.add("is-modal-open");
        if (backdrop) backdrop.hidden = false;
        lockScroll(true);
      } else {
        root.classList.remove("is-modal-open");
        if (backdrop) backdrop.hidden = true;
        lockScroll(false);
      }
    };
    media.addEventListener?.("change", onViewportChange);
  };

  const init = (scope = document) => {
    scope.querySelectorAll?.("[data-s26-stories]").forEach(initStories);
    if (scope.matches?.("[data-s26-stories]")) initStories(scope);
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
  document.addEventListener("shopify:section:unload", (event) => {
    const section = event.target?.matches?.("[data-s26-stories]")
      ? event.target
      : event.target?.querySelector?.("[data-s26-stories]");
    if (section) lockScroll(false);
  });
})();
